export const OUTLOOK365_OAUTH_ACTIONS = {
  LOGIN: 'OUTLOOK365_OAUTH_ACTIONS/LOGIN',
  HANDLE_CALLBACK: 'OUTLOOK365_OAUTH_ACTIONS/HANDLE_CALLBACK',
}
